export default class EventCustom {
  constructor(id, name, content, color, isDrawable) {
    this._id = id;
    this._name = name;
    this._content = content;
    this._color = color;
    this._isDrawable = isDrawable;
  }

  setIsDrawable(isDrawable) {
    this._isDrawable = isDrawable;
  }

  getId() {
    return this._id;
  }

  getName() {
    return this._name;
  }

  getContent() {
    return this._content;
  }

  getColor() {
    return this._color;
  }

  static getIsEditable() {
    return true;
  }

  getIsDrawable() {
    return this._isDrawable;
  }
}

module.exports = EventCustom;
